import { Link } from 'react-router-dom'
import { MEDIA_URL2 } from '../../axios'
import expresswayicon from '../../Assets/Home/expressway.svg'
import waterwaysicon from '../../Assets/Home/waterways.svg'

const SectorMenu = ({ isVisible, onMouseEnter, onMouseLeave }) => {

    const roadsicon = MEDIA_URL2 + 'Sectormenu/roads.svg'
    const tunnelsicon = MEDIA_URL2 + 'Sectormenu/tunnels.svg'
    const urbanicon = MEDIA_URL2 + 'Sectormenu/urban.svg'
    const railwayicon = MEDIA_URL2 + 'Sectormenu/railway.svg'
    const metroicon = MEDIA_URL2 + 'Sectormenu/metro.svg'
    // const labandmachinery = MEDIA_URL2 + 'Sectormenu/lab-equipment.png'
    const labandmachinery = 'https://cipl-aimantra.s3.amazonaws.com/website/sectorsdetail/lab-equipment.png'

    const sectormenudata = [
        {
            name: "Roads & Bridges",
            img: roadsicon,
            url: "Roads-&-Bridges",
        },
        {
            name: "Tunnels",
            img: tunnelsicon,
            url: "Tunnels",
        },

        {
            name: "Urban Infrastructure",
            img: urbanicon,
            url: "Urban-Infrastructure",
        },
        {
            name: "Railway",
            img: railwayicon,
            url: "Railway",
        },

        {
            name: "Metro",
            img: metroicon,
            url: "Metro",
        },

        {
            name: "Lab and Machinery",
            img: labandmachinery,
            url: "Lab-and-Machinery",
        },

        {
            name: "",
            img: "",
            url: "",
        },
    ]

    return (
    <div
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className={`z-10 fixed top-[37.5%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-wrap w-[90vw] md:w-[60vw] h-auto md:h-[50vh] max-h-[100vh] overflow-y-auto items-center gap-4 px-4 md:px-10 py-12 bg-white rounded-b-lg shadow-[0_0_30px_5px_rgba(0,0,0,0.1)] transition-all duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
    >
        {sectormenudata.map((i, index) => (
            <div key={index} className={`sectormenu-cont flex items-center justify-start flex-[1_1_50%] md:flex-[1_1_25%] rounded-md hover:scale-110 duration-300 hover:bg-[#21314061] ${index === sectormenudata.length - 1 ? 'pointer-events-none' : ''}`}>
                <Link to={"Sectors/" + i.url} className='w-full px-2 py-4 flex gap-1 items-center justify-start'>
                    <img src={i.img} alt={i.name} style={{ maxWidth: "35px" }} />
                    <p className='black font-semibold text-sm md:text-base'>{i.name}</p>
                </Link>
            </div>
        ))}
    </div>
)
}

export default SectorMenu